import {
    EVENTBRITE_FORMAT_IMAGE_MAPPING,
    EVENTBRITE_FORMAT_MAPPING_PLURAL,
    EVENTBRITE_REFINEMENT_TO_CATEGORY,
} from '@eventbrite/categories';
import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React from 'react';
import { Carousel, CarouselCard } from '../../../../components/Carousel';
import {
    ReadMore,
    ReadMoreContent,
    ReadMoreToggle,
} from '../../../../components/ReadMore';
import { CategoryBrowseBucket } from '../../components/CategoryBrowseBucket';
import { CATEGORY_CONTENT_MAP } from '../../constants';
import {
    useEnvContext,
    useRouteContext,
    useSearchContext,
} from '../../context';
import { useLocation } from '../../hooks/queries/location';
import { useAllTagsSortedByActiveCategory } from '../../hooks/queries/tags';
import { generateSearchUrl } from '../../utils';

export const CategoryBrowsePopularFormats: React.FunctionComponent = () => {
    const env = useEnvContext();
    const isBotRequest = env.isBotRequest;
    const popularFormatsKeys = useAllTagsSortedByActiveCategory(
        EVENTBRITE_FORMAT_MAPPING_PLURAL,
        'Format',
    );

    const routeInfo = useRouteContext();
    const activeCategory = routeInfo.match.params.category;
    const activeCategoryKey = EVENTBRITE_REFINEMENT_TO_CATEGORY[activeCategory];
    const activeTagDisplayname = CATEGORY_CONTENT_MAP[activeCategoryKey]?.title;

    //Data for generating link
    const { query } = useSearchContext();
    const { data: location } = useLocation();

    if (!location) {
        return null;
    }

    return (
        <CategoryBrowseBucket
            title={gettext('Explore %(activeTagDisplayname)s event formats', {
                activeTagDisplayname: activeTagDisplayname
                    .toString()
                    .toLowerCase(),
            })}
        >
            <ReadMore
                initialIsExpanded={isBotRequest}
                ariaLabel={gettext('Popular-formats').toString()}
            >
                <ReadMoreContent
                    previewContentType="pixel"
                    previewPixelCount={{
                        mobile: '420px',
                        tablet: '248px',
                        desktop: '172px',
                    }}
                >
                    <Carousel
                        cards={popularFormatsKeys}
                        noScrollMobile={true}
                        justifyContentValue={'space-between'}
                    >
                        {(popularFormat = '') => (
                            <a
                                key={popularFormat}
                                href={generateSearchUrl(
                                    {
                                        ...query,
                                        tags: [
                                            activeCategoryKey,
                                            popularFormat || '',
                                        ],
                                    },
                                    location,
                                    false,
                                )}
                                onClick={() => {
                                    trackAnalyticsEvent({
                                        category: 'category-page',
                                        action: 'FormatCardClicked',
                                        label: EVENTBRITE_FORMAT_MAPPING_PLURAL[
                                            popularFormat
                                        ],
                                    });
                                }}
                            >
                                <CarouselCard
                                    style="horizontal"
                                    title={
                                        EVENTBRITE_FORMAT_MAPPING_PLURAL[
                                            popularFormat
                                        ] || ''
                                    }
                                    imageUrl={
                                        EVENTBRITE_FORMAT_IMAGE_MAPPING[
                                            popularFormat
                                        ]?.link
                                    }
                                />
                            </a>
                        )}
                    </Carousel>
                </ReadMoreContent>
                <ReadMoreToggle
                    labels={{
                        show: gettext('View more'),
                        hide: gettext('View less'),
                    }}
                />
            </ReadMore>
        </CategoryBrowseBucket>
    );
};
